import get from "lodash/get";
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { SocialShare } from "@quintype/components";

import Button from "../../atoms/Button";
import Headline from "../../atoms/Headline";
import { useDeviceType } from "../../customHooks/useDeviceType";
import { STATIC_KEYWORDS } from "../../../constants";
import { StoryCard } from "../../molecules";
import { SocialShareTemplate } from "../../../arrow";
import ListingAdSlot from "../../molecules/ListingAdSlot";
import { getAdvancedSearchItems } from "../../../../api/utils";
import { trackLoadMoreClick } from "../../utils";

import "./tag.m.css";
import CircleIcon from "../../atoms/Circle";

const TagPage = (props) => {
  const { LOAD_MORE } = STATIC_KEYWORDS;
  const [tagPageStories, setStories] = useState(props?.data?.stories);
  const [offset, setOffset] = useState(11);
  const [limit, setLimit] = useState(11);
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const { total, name, description, slug } = get(props, ["data", "tag"]) ?? {};
  const [hideLoadMore, setHideLoadMore] = useState(false);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "dl_page_info",
      cms_author_name: "NA",
      byline: "NA",
      category: "topic",
      sub_category: props?.data?.tag?.slug || "NA",
      content_id: "NA",
      template_name: "listing",
      publish_date: "NA",
      publish_time: "NA",
      login_status: "not-logged-in", // will be changed
      subscription_status: "not-subscribed", // will be changed
      ad_free: false, // will be changed
      login_wall_enabled: false,
      platform: window.innerWidth >= 768 ? "Desktop" : "Mobile",
    });
  }, []);

  useEffect(() => {
    const remaining = total - tagPageStories.length;
    setOffset(tagPageStories.length);
    remaining < limit && setLimit(remaining);
    remaining === 0 && setHideLoadMore(true);
  }, [tagPageStories]);

  const getMoreStories = async (offset, limit) => {
    trackLoadMoreClick({
      linkCategory: "topic",
      category: "topic",
      subCategory: slug,
      templateName: "listing",
    });
    const splitTagSlug = slug.split("-").join(" ");
    const newStories = await getAdvancedSearchItems("tag-name-lower", splitTagSlug, offset, limit);
    setStories((prevStories) => [...prevStories, ...newStories]);
  };

  return (
    <div className="container" styleName="tag-page-container">
      <div styleName="tag-page-title" style={description?.trim().length === 0 ? { marginBottom: "0px" } : undefined}>
        <div styleName="title-wrapper">
          <Headline type={1}>
            {isDesktop && <CircleIcon width="24" height="24" />}
            {name || "Tag Page"}
          </Headline>
          <p styleName="total-stories">{`(${total} search result${total === 1 ? "" : "s"})`}</p>
        </div>

        <SocialShare template={SocialShareTemplate} fullUrl={encodeURI(props?.data?.url)} title={props?.data?.title} />
      </div>
      <div styleName="tag-page-description">
        <div styleName="h3-ranking-sub-headline">{description}</div>
      </div>
      {total === 0 ? (
        <div styleName="not-found-text">Oops! We couldn’t find any results for '{name}' Please try again.</div>
      ) : (
        <div styleName="stories-container">
          {tagPageStories?.map((story, index) => (
            <>
              <StoryCard
                key={story?.story?.id}
                story={story?.story}
                showAuthorContent={false}
                tagPage={true}
                firstTagPage={index === 0}
              />
              {index === 1 && (
                <div styleName="desktop-ad">
                  <ListingAdSlot
                    adType={"right_side"}
                    index={index}
                    pageType={"tag-page"}
                    adStyleName="ad-slot-size-300x250"
                    adSlotConfigName="mRec_ad"
                  />
                </div>
              )}
              {index === 0 && !isDesktop && (
                <div styleName="mobile-ad">
                  <ListingAdSlot
                    adType={"right_side"}
                    index={index}
                    pageType={"tag-page"}
                    adStyleName="ad-slot-size-300x250"
                    adSlotConfigName="mRec_ad"
                  />
                </div>
              )}
              {(index === 6 || ((index - 11) % 5 === 0 && index - 11 >= 0)) && (
                <div styleName="desktop-ad">
                  <ListingAdSlot
                    adType={"grid_ad"}
                    index={index}
                    pageType={"tag-page"}
                    adStyleName="ad-slot-size-300x250"
                    adSlotConfigName="mRec_ad"
                  />
                </div>
              )}
              {index % 3 === 0 && index > 0 && !isDesktop && (
                <div styleName="mobile-ad">
                  <div styleName="tag-ad-container">
                    <ListingAdSlot
                      adType={"grid_ad"}
                      index={index}
                      pageType={"tag-page"}
                      adStyleName="ad-slot-size-300x250"
                      adSlotConfigName="mRec_ad"
                    />
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      )}
      {!hideLoadMore && (
        <div styleName="load-more-button">
          <Button onClickFunction={() => getMoreStories(offset, limit)}>{LOAD_MORE}</Button>
        </div>
      )}
    </div>
  );
};

export { TagPage };
TagPage.propTypes = {
  data: PropTypes.object,
};
